export const TYPES = {
    GET_USER_DATA : "GET_USER_DATA",
    UNAUTHORIZED : "UNAUTHORIZED",
    IS_SUPER_ADMIN : "IS_SUPER_ADMIN"
}